'use strict';

var simpleMerge = require('./simpleMerge');

function simpleClone(obj) {
  return simpleMerge({}, obj);
}

module.exports = simpleClone;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/simpleClone.js
// module id = 42
// module chunks = 1